// extracted by mini-css-extract-plugin
module.exports = {"icon":"style__icon__Ib51E","stretch":"style__stretch__fumTt","navLink":"style__navLink__m7ARB","labelGroup":"style__labelGroup__YhsCm","labelPart":"style__labelPart__M3z7N"};